import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import photoicon from "../assets/icons/photoicon.png";
interface IProps {
  onChange: Function;
  previewImageUrl?: string;
  iconAreaHeight: number | string;
  containerWidth: number | string;
  containerHeight: number | string;
  iconWidth: number | string;
  iconHeight: number | string;
}
const placeholderImage =
  "https://images.unsplash.com/photo-1591871937573-74dbba515c4c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8NHx8fGVufDB8fHx8&w=1000&q=80";
export const ImageUploadPreview = (props: IProps) => {
  const { onChange } = props;
  const classes = useStyles(props);
  return (
    <label className={classes.label}>
      <div className={classes.container}>
        <input
          onChange={(event: any) => {
            onChange(event.target.files[0]);
          }}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
        />
        <div className={classes.iconArea}>
          <img
            src={photoicon}
            alt="icon"
            width={props.iconWidth}
            height={props.iconHeight}
            className={classes.photoIcon}
          ></img>
        </div>
      </div>
    </label>
  );
};
const useStyles = makeStyles({
  photoIcon: {
    marginTop: 0,
  },
  iconArea: {
    backgroundColor: "grey",
    marginTop: "auto",
    position: "absolute",
    height: (props: IProps) => props.iconAreaHeight,
    width: "100%",
    bottom: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    textAlign: "center",
  },
  container: {
    width: (props: IProps) => props.containerWidth,
    height: (props: IProps) => props.containerHeight,
    backgroundImage: (props: IProps) =>
      `url("${props?.previewImageUrl ?? placeholderImage}")` ?? "",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    position: "relative",
    borderRadius: 4,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    cursor: "pointer",
  },
  label: {
    cursor: "pointer",
  },
});
